import PlaceholderImage from "images/placeholder.jpg"
import PlaceholderEvent from "images/placeholder.jpg"

const usePlaceholder = (is_event = true) => {
    return is_event ? PlaceholderEvent : PlaceholderImage;
};

export default usePlaceholder;